import FaqEditController from './bc/faq/faq-edit.controller';
import ReleaseNotesEditController from './bc/releaseNotes/releaseNotes-edit.controller';
import faqEditTpl from './bc/faq/faq.edit.html';
import changelogEditTpl from './bc/releaseNotes/releaseNotes.edit.html';

export default function contentEditorRouter($stateProvider) {
  $stateProvider
    .state('app.faq_edit', {
      url: '/faq/edit/:sectionToEdit/:language',
      params: {
        sectionToEdit: null,
        language: null,
      },
      templateUrl: faqEditTpl,
      controller: FaqEditController,
      controllerAs: 'vm',
      data: {
        authorizedPermissions: ['EDITORIAL'],
      },
    })
    .state('app.changelog_edit', {
      url: '/release_notes/edit/:language',
      params: {
        sectionToEdit: null,
        language: null,
      },
      templateUrl: changelogEditTpl,
      controller: ReleaseNotesEditController,
      controllerAs: 'vm',
      data: {
        authorizedPermissions: ['EDITORIAL'],
      },
    });
}



// WEBPACK FOOTER //
// ./src/app/content-editor/content-editor.router.js